module.exports = __webpack_public_path__ + "img/icon_classify01.aa09d29c.png";